import React, { Component } from "react";
import { connect } from "react-redux";
import { initialize } from "redux-form";

import { userLoginRequest, setUserLoginTitle } from "../../actions/auth";

import LoginForm from './Form/LoginForm';

import Image from '../../assets/images/orange-white.png';

import { REMEMBER_ME_LOCAL_STORAGE_KEY, TOKEN_LOCAL_STORAGE_KEY } from "../../config/constants";
import { routes } from "../../config/routes";
import { Toast } from "../../helpers/toast";
import { INVALID_EMAIL_OR_PASSWORD } from "../../config/labels";
import { withRouter } from "react-router-dom";

class Login extends Component {
  render() {
    const { loginTitle, loginDesc } = this.props;
    return (
      <div className="login-sec">
        <div className="login-blk">
          <div className="top-logo">
            <i><img src={Image} alt="" /></i>
            {
              loginTitle
                ?
                <h2>{loginTitle}</h2>
                :
                <h2>Clinic booking made easy </h2>
            }
            {loginDesc && <p className="reg-succ" dangerouslySetInnerHTML={{ __html: loginDesc }}></p>}
          </div>
          <LoginForm onSubmit={this.handleSubmit} loginTitle={loginTitle} />
        </div>
      </div>
    );
  }

  componentDidMount() {
    const value = JSON.parse(localStorage.getItem(REMEMBER_ME_LOCAL_STORAGE_KEY));
    const payload = { email: value?.email, password: value?.password, checkbox: value ? true : false };
    this.props.dispatch(initialize("login_form", payload));
  }

  componentDidUpdate(prevProps, prevState) {
    const { loginLoading, loginUserDetails, history } = this.props;
    if (!loginLoading && prevProps.loginLoading !== loginLoading) {
      if (loginUserDetails) {
        setTimeout(() => {
          history.push(routes.BASEPATH);
        }, 0);
      } else {
        Toast({ type: 'error', message: INVALID_EMAIL_OR_PASSWORD });
      }
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    const title = '';
    const desc = '';
    dispatch(setUserLoginTitle(title, desc));
  }


  handleSubmit = data => {
    // localStorage.removeItem(TOKEN_LOCAL_STORAGE_KEY);
    const { dispatch } = this.props;
    const payload = {
      email: data.email,
      password: data.password
    };
    if (data.checkbox) {
      const { email } = data;
      const payload = JSON.stringify({ email });
      localStorage.setItem(REMEMBER_ME_LOCAL_STORAGE_KEY, payload);
    } else {
      localStorage.removeItem(REMEMBER_ME_LOCAL_STORAGE_KEY);
    }
    dispatch(userLoginRequest(payload));
  };
}

const mapStateToProps = (state) => {
  const { auth } = state;
  return {
    loginLoading: auth.get('loginLoading'),
    loginUserDetails: auth.get('loginUserDetails'),
    loginTitle: auth.get('loginTitle'),
    loginDesc: auth.get('loginDesc'),
  }
}

Login = withRouter(Login);
export default connect(mapStateToProps)(Login);
